import { render, staticRenderFns } from "./JobApplicationQuickView.vue?vue&type=template&id=4852fb20"
import script from "./JobApplicationQuickView.vue?vue&type=script&lang=js"
export * from "./JobApplicationQuickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports